import { computed, ref } from '@vue/composition-api'

export default <T>(array: Array<T>) => {
  const index = ref(0)

  const value = computed(() => array[index.value])

  const next = () => {
    index.value++

    if (index.value === array.length) {
      index.value = 0
    }
  }

  const prev = () => {
    index.value--

    if (index.value < 0) {
      index.value = array.length - 1
    }
  }

  return {
    value,
    next,
    prev
  }
}
